import { ReactElement } from "react";
import { IPanelProps, ISafetyResult } from "./types";
import RowComponent from "../../components/rowComponent";
import TextField from "@mui/material/TextField";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { cloneObject } from "../../../../system/utils";


const SafetyPanel = ({ value, property, onChange }: IPanelProps<ISafetyResult>): ReactElement => {

  const handleValue = (prop: keyof ISafetyResult, selectedValue: any) => {
    const newValue = cloneObject(value);

    newValue[prop].value = selectedValue;
    onChange(property, newValue);
  };

  const onChangeComment = (prop: keyof ISafetyResult, comment: string) => {
    const newValue = cloneObject(value);

    newValue[prop].comment = comment;
    onChange(property, newValue);
  };

  return (
    <div className="display-flex-column gap-1 p-1">
      <RowComponent title="Incidents" ratio={.2} >
        <div className="row-content-2 ">
          <ToggleButtonGroup
            fullWidth={true}
            value={value.incidents.value}
            exclusive={true}
            onChange={(_event, selectedValue) => handleValue("incidents", selectedValue)}>
            <ToggleButton value={true} >YES</ToggleButton>
            <ToggleButton value={false} >NO</ToggleButton>
          </ToggleButtonGroup>

          <TextField
            variant="outlined"
            placeholder="to be filled..."
            multiline={true}
            minRows={4}
            maxRows={4}
            value = {value.incidents.comment}
            fullWidth={true}
            onChange={event => onChangeComment("incidents", event.target.value)}
          />
        </div>
      </RowComponent>
      <RowComponent title="PRA's & Contracting Out" ratio={.2} >
        <div className="row-content-2">
          <ToggleButtonGroup
            fullWidth={true}
            value={value.prasAndContractingOut.value}
            exclusive={true}
            onChange={(_event, selectedValue) => handleValue("prasAndContractingOut", selectedValue)}>
            <ToggleButton value={true} >YES</ToggleButton>
            <ToggleButton value={false} >NO</ToggleButton>
          </ToggleButtonGroup>
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            multiline={true}
            minRows={4}
            maxRows={4}
            value = {value.prasAndContractingOut.comment}
            fullWidth={true}
            onChange={event => onChangeComment("prasAndContractingOut", event.target.value)}
          />
        </div>
      </RowComponent>
    </div>
  );
};

export default SafetyPanel;